import reducer from './drawerMenuMobile.reducer';
import * as action from './drawerMenuMobile.action';
import * as selector from './drawerMenuMobile.selector';
import * as constant from './drawerMenuMobile.constant';
import initialState from './drawerMenuMobile.initialState';
import subscriber from './drawerMenuMobile.subscriber';
import saga from './drawerMenuMobile.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  subscriber,
  saga,
  name: constant.NAME,
};
